import { apiRequest } from '@/utils/api-request';

export type UploadFileTypesResponse = {
  detail?: string;
  data?: {
    accepted_file_types: string[];
    structured_data_file_types?: string[];
    max_upload_size: number;
    max_upload_size_mb: number;
    // Files with these MIME types use the S3 presigned multipart flow and
    // are permitted up to `max_multipart_upload_size_mb`, not `max_upload_size_mb`.
    multipart_upload_mime_types?: string[];
    max_multipart_upload_size?: number;
    max_multipart_upload_size_mb?: number;
    // True when the org has app-level encryption enabled. The presigned
    // multipart path is blocked server-side for these orgs; the FE must use
    // the single-part POST uploader (capped at max_upload_size_mb).
    app_encryption_enabled?: boolean;
    soft_delete_ttl_seconds: number;
    soft_delete_ttl_value: number;
    soft_delete_ttl_unit: string;
  };
};

export const getUploadFileTypes =
  async (): Promise<UploadFileTypesResponse> => {
    const response = await apiRequest({
      url: '/uploads/policy',
      target: 'platform',
      method: 'GET',
    });

    if (response?.detail) {
      return {
        detail: response.detail || 'Failed to get allowed upload file types',
      };
    }

    return response as UploadFileTypesResponse;
  };
